var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _g, _g2, _path, _path2, _text, _text2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGreenSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 951.79 932.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#f9e415;}.c{fill:#ffca0e;}.d{fill:#408736;}.e{fill:#61b045;}.f{fill:#f5b134;font-family:Poppins-Light, Poppins;font-size:42.97px;}.g{fill:#4b9641;font-family:Poppins-Bold, Poppins;font-size:54.86px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "210.9 436.04 234.04 377.51 0 337.47 210.9 436.04"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "253.19 331.67 297.61 287.09 119.89 181.7 253.19 331.67"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "333.34 252.57 391.78 229.21 246.62 11.19 333.34 252.57"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "438.25 211.65 501.17 213.34 458.9 21.75 438.25 211.65"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "550.79 215.61 607.91 242.06 666.99 0 550.79 215.61"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "652.58 263.79 694.56 310.68 806.36 142.07 652.58 263.79"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "726.98 348.32 746.97 408 951.79 287.89 726.98 348.32"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M767.29,530.72l7.45-13.55s-129.36-6.77-222.15,112.43c0,0-74.41,103.92-62.31,153.75l277.01-252.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M774.74,517.18s-17.61,243.15-284.46,266.18c0,0,55.54-148.33,284.46-266.18Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M199.94,530.72l-7.45-13.55s129.36-6.77,222.15,112.43c0,0,74.41,103.92,62.31,153.75l-277.01-252.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M192.49,517.18s17.61,243.15,284.46,266.18c0,0-55.54-148.33-284.46-266.18Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M740.53,477.9h34.2s8.47-142.91-135.8-241.45c-144.26-98.55-313.12-6.66-358.23,37.81l-25.42,93.15s83.43-160.93,277.48-133.5c194.04,27.43,207.76,241.79,207.76,241.79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M188.2,477.9h37.25s8.13-218.77,240.44-281.75c0,0-244.84,1.02-277.69,281.75Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(158.59 852.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Greensun Eco-Friendly"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "f",
    transform: "translate(292.25 907.85)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cleaning Services"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "343.24 349.6 314.46 349.6 299.5 356.51 299.5 381.53 356.19 479.7 356.19 476.43 356.19 357.66 343.24 349.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "484.94 340.68 476.17 340.68 476.17 382.12 466.96 382.12 466.96 417.22 458.9 417.22 458.9 486.34 484.94 486.34 484.94 340.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "433.01 374.06 422.94 374.06 422.94 366.87 421.21 366.87 421.21 340.68 418.05 361.4 418.05 373.48 410.85 373.48 410.85 366 400.95 373.63 400.95 474.24 433.01 485.37 433.01 374.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "531.12 416.64 524.22 416.64 524.22 382.69 514.15 382.69 514.15 340.68 502 340.68 502 486.34 531.12 486.34 531.12 416.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "383.9 386.75 374.6 393.91 369.13 393.91 369.13 463.19 383.9 468.32 383.9 386.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M657.15,500.08v-4.89h-6.33v-8.34h-12.95v-10.36h-8.63v-7.48l-16.69-19.85h-5.75v-4.6h-3.74v4.89h-6.04l-16.11,19.85v7.19h-6.91v9.49h-14.39v9.78h-6.04v1.44h2.01v27.05h-9.78v10.93l-8.34,.58v-20.43l-6.33-8.34v-3.89h-72.22v1.59l-6.19,6.19v24.89h-19.71v-32.65l-63.88-22.18v21.2l2.51,4.34-2.51,1.45v27.84h-12.95v-21.95l-56.68-98.18v101.43l.11,.05s138.64,54.87,185.33,200.3c0,0,23.69-121.42,171.5-193.73h-1.02v-23.59h1.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "369.13 502.13 369.13 507.92 371.64 506.47 369.13 502.13"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGreenSun);
export default __webpack_public_path__ + "static/media/LogoGreenSun.bcc5f848c9e9fb4464b40d4776119929.svg";
export { ForwardRef as ReactComponent };